import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Button, Grid, InputAdornment, TextField, Typography, } from "@mui/material";
import { Check, Pencil } from "@phosphor-icons/react";
import { useEffect, useState } from "react";
import "./OfferModal.scss";
import { convertToNLEuroFormat } from "../../../application/common/utils/helper";
import { useTranslation } from "react-i18next";
const OfferLeadObjectPrice = ({ leadObject, index, updatePriceOfLeadObject, }) => {
    var _a;
    const [leadObjectEntity, setleadObjectEntity] = useState(leadObject);
    const [displayDiscount, setDisplayDiscount] = useState(false);
    const [discount, setdiscount] = useState(0);
    const [translate] = useTranslation();
    const savePrice = (data) => {
        updatePriceOfLeadObject(index, data);
    };
    const handleDiscount = (event) => {
        let inputValue = event.target.value;
        // Ensure input is a number
        if (!isNaN(inputValue)) {
            // Clamp input value to maximum of 100
            inputValue = Math.min(inputValue, 100);
            let newPrice = leadObject.price - (inputValue / 100) * leadObject.price;
            const updatedData = Object.assign(Object.assign({}, leadObjectEntity), { updatedPrice: parseFloat((newPrice > 395 ? newPrice : 395).toFixed(1)) });
            let maxDiscount = ((leadObject.price - 395) / leadObject.price) * 100;
            setdiscount(inputValue <= maxDiscount
                ? parseFloat(inputValue.toFixed(1))
                : parseFloat(maxDiscount.toFixed(1)));
            // Update the state with the new object
            setleadObjectEntity(updatedData);
        }
    };
    const handleObjectAmountChange = (event) => {
        let inputValue = event.target.value;
        // Ensure input is a number
        if (!isNaN(inputValue)) {
            // Clamp input value to maximum of oringnal price
            const newPrice = parseFloat(
            // inputValue <= leadObject.price ?
            inputValue
            //  : leadObject.price
            );
            const updatedData = Object.assign(Object.assign({}, leadObjectEntity), { updatedPrice: parseFloat(newPrice.toFixed(1)) });
            // Update the state with the new object
            setleadObjectEntity(updatedData);
        }
    };
    const handleObjectAmountBlur = () => {
        var _a, _b;
        // let newPrice =
        // leadObjectEntity.price <= leadObject.price ? leadObjectEntity.price : leadObject.price;
        let newPrice = (_b = (leadObjectEntity &&
            (((_a = leadObjectEntity.updatedPrice) !== null && _a !== void 0 ? _a : 0 > 395)
                ? leadObjectEntity.updatedPrice
                : 395))) !== null && _b !== void 0 ? _b : 0;
        const updatedData = Object.assign(Object.assign({}, leadObjectEntity), { updatedPrice: parseFloat(newPrice.toFixed(1)) });
        let discount = 100 - (newPrice / leadObject.price) * 100;
        setdiscount(parseFloat(discount.toFixed(1)));
        // Update the state with the new object
        setleadObjectEntity(updatedData);
    };
    useEffect(() => {
        if (leadObject) {
            const updatedData = Object.assign(Object.assign({}, leadObjectEntity), { updatedPrice: parseFloat(leadObject.price.toFixed(1)) });
            setleadObjectEntity(updatedData);
        }
    }, []);
    return (_jsxs(Grid, { container: true, size: {
            lg: 12,
            xs: 12
        }, sx: {
            justifyContent: "space-between"
        }, children: [_jsx(Grid, { children: ((_a = leadObjectEntity.objectFullAddress) === null || _a === void 0 ? void 0 : _a.trim()) ? (_jsx(Typography, { variant: "body1", children: leadObjectEntity.objectFullAddress })) : (_jsxs(_Fragment, { children: [_jsxs(Typography, { variant: "body1", children: [" ", leadObjectEntity.street] }), _jsxs(Typography, { variant: "body1", children: [leadObjectEntity.houseNumber, " ", leadObjectEntity.addition, leadObjectEntity.city] })] })) }), _jsxs(Grid, { className: `grid-container ${displayDiscount ? "visible" : ""}`, sx: {
                    display: displayDiscount ? "flex" : "none",
                    flexDirection: { xs: "column", md: "row" },
                    gap: { xs: 1, sm: 2 },
                    alignItems: "center"
                }, children: [_jsx(Typography, { variant: "body1", sx: {
                            fontWeight: 500
                        }, children: translate("discount") }), _jsxs(Box, { sx: {
                            display: "flex",
                            gap: 1
                        }, children: [_jsx(Box, { sx: {
                                    width: "120px"
                                }, children: _jsx(TextField, { variant: "outlined", size: "small", value: discount, type: "number", onChange: (e) => handleDiscount(e), 
                                    // inputProps={{ min: 0 }}
                                    sx: {
                                        minHeight: "0 !important",
                                        padding: "0 !important",
                                        paddingLeft: "15px",
                                    }, style: { height: "0 !important" }, slotProps: {
                                        input: {
                                            endAdornment: _jsx(InputAdornment, { position: "end", children: "%" }),
                                        }
                                    } }) }), _jsx(Box, { sx: {
                                    width: "120px"
                                }, children: _jsx(TextField, { variant: "outlined", size: "small", value: leadObjectEntity.updatedPrice, onChange: handleObjectAmountChange, onBlur: handleObjectAmountBlur, sx: {
                                        minHeight: "0 !important",
                                        padding: "0 !important",
                                        paddingLeft: "15px",
                                    }, style: { height: "0 !important" }, slotProps: {
                                        input: {
                                            startAdornment: (_jsx(InputAdornment, { position: "start", children: "\u20AC" })),
                                        }
                                    } }) })] }), _jsx(Button, { sx: {
                            borderRadius: "var(--1, 8px)",
                            background: "var(--n-primary, #130922)",
                            padding: "4px",
                            height: "32px",
                            minWidth: "32px !important",
                        }, onClick: () => {
                            const timer = setTimeout(() => {
                                setDisplayDiscount(false);
                                savePrice(leadObjectEntity);
                            }, 400); // Adjust the delay time as needed (in milliseconds)
                            return () => clearTimeout(timer);
                        }, children: _jsx(Check, { size: 24, color: "white" }) })] }), _jsxs(Grid, { className: `grid-container ${!displayDiscount ? "visible" : ""}`, sx: {
                    display: !displayDiscount ? "flex" : "none"
                }, children: [_jsx(Typography, { variant: "body1", sx: {
                            color: "var(--n-jetblack, #312F2F)",
                            fontWeight: 500,
                            paddingRight: "15px !important"
                        }, children: convertToNLEuroFormat(leadObjectEntity.updatedPrice) }), _jsx(Button, { sx: {
                            borderRadius: "var(--1, 8px)",
                            background: "var(--n-primary, #130922)",
                            padding: "4px",
                            height: "32px",
                            minWidth: "32px !important",
                        }, onClick: () => {
                            const timer = setTimeout(() => {
                                setDisplayDiscount(true);
                            }, 400); // Adjust the delay time as needed (in milliseconds)
                            return () => clearTimeout(timer);
                        }, children: _jsx(Pencil, { size: 24, color: "white" }) })] })] }));
};
export default OfferLeadObjectPrice;
